import { defineRecipe } from '@chakra-ui/react'

export const buttonRecipe = defineRecipe({
  className: 'ui-button',
  base: {
    alignItems: 'center',
    border: '[1px solid transparent]',
    borderRadius: '[16px]',
    cursor: '[pointer]',
    display: 'inline-flex',
    fontWeight: '[600]',
    gap: '[10px]',
    justifyContent: 'center',
    lineHeight: '[1.2]',
    transition:
      '[transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, opacity 0.2s ease]',
    _focusVisible: {
      boxShadow: '[0 0 0 3px var(--input-focus-ring)]',
    },
    _disabled: {
      cursor: '[not-allowed]',
      opacity: '[0.6]',
    },
  },
  variants: {
    variant: {
      primary: {
        bg: 'var(--action-primary-background)',
        color: 'var(--action-primary-foreground)',
        boxShadow: '[var(--shadow-sm)]',
        _hover: {
          transform: '[translateY(-1px)]',
          bg: 'var(--action-primary-background-hover)',
          boxShadow: '[var(--shadow-md)]',
        },
        _disabled: {
          transform: '[none]',
          boxShadow: '[none]',
        },
      },
      secondary: {
        bg: 'var(--action-secondary-background)',
        color: 'var(--action-secondary-foreground)',
        borderColor: 'var(--control-border)',
        _hover: {
          bg: 'var(--action-secondary-background-hover)',
          borderColor: 'var(--control-border-hover)',
        },
      },
      ghost: {
        bg: 'transparent',
        color: 'var(--theme-text-color)',
        _hover: { bg: 'var(--action-secondary-background-hover)' },
      },
      danger: {
        bg: 'var(--error-bg-translucent)',
        color: 'var(--error-fg)',
        _hover: { bg: 'var(--error-bg-translucent-hover)' },
        _disabled: { bg: 'var(--error-bg-translucent)' },
      },
      menu: {
        bg: 'transparent',
        color: 'var(--theme-text-color)',
        justifyContent: '[flex-start]',
        width: '[100%]',
        _hover: { bg: 'var(--theme-accent-background)' },
      },
      plain: {
        bg: 'transparent',
        color: '[inherit]',
        boxShadow: '[none]',
        _hover: { bg: 'transparent' },
      },
    },
    size: {
      sm: { fontSize: '[13px]', minH: '[44px]', px: '[14px]', py: '[8px]' },
      md: { fontSize: '[14px]', minH: '[44px]', px: '[20px]', py: '[12px]' },
      lg: { fontSize: '[15px]', minH: '[52px]', px: '[28px]', py: '[14px]' },
    },
    iconOnly: {
      true: { px: '[0]', py: '[0]', minW: '[44px]' },
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
})
